import React from 'react';
import styled from "styled-components";
import ALERT_MAP from "../../../maps/alertMap";
import Paper from "@mui/material/Paper";
import {colors} from "../../../maps/colors";

const WrapperStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 50px;
`;

const AlertItemStyled = styled.div`

`;

const AlertItemTitleStyled = styled.div`
    font-size: 24px;
    padding: 10px;
`;

const AlertItemListOfLogsStyled = styled.div`
    padding: 5px 10px;
    margin: 3px 0;
    border-radius: 5px;
`;

const AlertItemListOfLogItemStyled = styled.div`
    border-left: 6px solid;
    border-bottom-width: 2px;
    border-bottom-color: rgba(145, 158, 171, 0.2);
    padding-left: 15px;
    margin-bottom: 6px;
    
    &.INFO {
        border-color: ${colors.LIGHT_GREEN};
    }

    &.CRITICAL {
        border-color: ${colors.WARM_RED};
    }

    &.WARNING {
        border-color: ${colors.LIGHT_ORANGE};
    }
`;

const TitleStyled = styled.div`
    font-weight: 600;
    line-height: 1.57143;
    font-size: 0.875rem;
    font-family: "Public Sans", sans-serif;
`;

const DateStyled = styled.div`
    display: flex;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    line-height: 1.5;
    font-size: 0.75rem;
    font-family: "Public Sans", sans-serif;
    font-weight: 400;
    color: rgb(145, 158, 171);
`;

const InventoryAlertsMain = () => {
    return (
        <WrapperStyled>
            {ALERT_MAP.values.map(pp => {
                return (
                    <AlertItemStyled>
                        <Paper>
                            <AlertItemTitleStyled key={pp.name}>{pp.name}</AlertItemTitleStyled>
                            <AlertItemListOfLogsStyled>
                                <AlertItemListOfLogItemStyled className={"CRITICAL"}>
                                    <TitleStyled>Field - 1, Shelf - A58</TitleStyled>
                                    <DateStyled>
                                        1 min ago, 9:38 - 4 apr
                                    </DateStyled>
                                </AlertItemListOfLogItemStyled>
                                <AlertItemListOfLogItemStyled className={"INFO"}>
                                    <TitleStyled>Field - 1, Shelf - A58</TitleStyled>
                                    <DateStyled>
                                        1 min ago, 9:38 - 4 apr
                                    </DateStyled>
                                </AlertItemListOfLogItemStyled>
                                <AlertItemListOfLogItemStyled className={"WARNING"}>
                                    <TitleStyled>Field - 1, Shelf - A58</TitleStyled>
                                    <DateStyled>
                                        1 min ago, 9:38 - 4 apr
                                    </DateStyled>
                                </AlertItemListOfLogItemStyled>
                                <AlertItemListOfLogItemStyled className={"INFO"}>
                                    <TitleStyled>Field - 1, Shelf - A58</TitleStyled>
                                    <DateStyled>
                                        1 min ago, 9:38 - 4 apr
                                    </DateStyled>
                                </AlertItemListOfLogItemStyled>
                                <AlertItemListOfLogItemStyled className={"WARNING"}>
                                    <TitleStyled>Field - 1, Shelf - A58</TitleStyled>
                                    <DateStyled>
                                        1 min ago, 9:38 - 4 apr
                                    </DateStyled>
                                </AlertItemListOfLogItemStyled>
                                <AlertItemListOfLogItemStyled className={"CRITICAL"}>
                                    <TitleStyled>Field - 1, Shelf - A58</TitleStyled>
                                    <DateStyled>
                                        1 min ago, 9:38 - 4 apr
                                    </DateStyled>
                                </AlertItemListOfLogItemStyled>
                                <AlertItemListOfLogItemStyled className={"INFO"}>
                                    <TitleStyled>Field - 1, Shelf - A58</TitleStyled>
                                    <DateStyled>
                                        1 min ago, 9:38 - 4 apr
                                    </DateStyled>
                                </AlertItemListOfLogItemStyled>
                            </AlertItemListOfLogsStyled>
                        </Paper>
                    </AlertItemStyled>
                );
            })}
        </WrapperStyled>
    );
};

export default InventoryAlertsMain;